import gql from 'graphql-tag'

export const READ_USERNAME = gql`
  query ReadUserName($userID: ID!) {
    User(id: $userID) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/user.js